module.exports = function getResource(label, vars = []) {
    let resources = {
        liveChat: 'Live Chat'
    };

    return resources[label];
};
